export const questionList = [
  {
    question: 'Где я могу посмотреть на ваши работы?',
    answer:
      'С нашими работами можно ознакомиться на сайте в разделе "Шоурумы" (посмотреть фото, видео-контент, 3Д-туры или перейти в инстаграм), а также у нас есть "физические" шоурумы в строящихся ЖК. Для записи на просмотр шоурума можно обратиться в отдел продаж, колл-центр или оставить заявку на нашем сайте.',
  },
  {
    question: 'Где я могу посмотреть на ваши работы?',
    answer:
      'С нашими работами можно ознакомиться на сайте в разделе "Шоурумы" (посмотреть фото, видео-контент, 3Д-туры или перейти в инстаграм), а также у нас есть "физические" шоурумы в строящихся ЖК. Для записи на просмотр шоурума можно обратиться в отдел продаж, колл-центр или оставить заявку на нашем сайте.',
  },
  {
    question: 'Оплата сразу 100% или есть график?',
    answer:
      'С нашими работами можно ознакомиться на сайте в разделе "Шоурумы" (посмотреть фото, видео-контент, 3Д-туры или перейти в инстаграм), а также у нас есть "физические" шоурумы в строящихся ЖК. Для записи на просмотр шоурума можно обратиться в отдел продаж, колл-центр или оставить заявку на нашем сайте.',
  },
  {
    question: 'Что входит в стоимость ремонта квартиры?',
    answer:
      'С нашими работами можно ознакомиться на сайте в разделе "Шоурумы" (посмотреть фото, видео-контент, 3Д-туры или перейти в инстаграм), а также у нас есть "физические" шоурумы в строящихся ЖК. Для записи на просмотр шоурума можно обратиться в отдел продаж, колл-центр или оставить заявку на нашем сайте.',
  },
  {
    question: 'Я могу поменять материал пакетов?',
    answer:
      'С нашими работами можно ознакомиться на сайте в разделе "Шоурумы" (посмотреть фото, видео-контент, 3Д-туры или перейти в инстаграм), а также у нас есть "физические" шоурумы в строящихся ЖК. Для записи на просмотр шоурума можно обратиться в отдел продаж, колл-центр или оставить заявку на нашем сайте.',
  },
  {
    question: 'В какой срок осуществляется ремонт?',
    answer:
      'С нашими работами можно ознакомиться на сайте в разделе "Шоурумы" (посмотреть фото, видео-контент, 3Д-туры или перейти в инстаграм), а также у нас есть "физические" шоурумы в строящихся ЖК. Для записи на просмотр шоурума можно обратиться в отдел продаж, колл-центр или оставить заявку на нашем сайте.',
  },
];
